import React from 'react';
import { FormattedMessage } from 'react-intl';
import config from 'config';

import theme from './HeaderStatus.scss';

const propTypes = {};
const defaultProps = {};

const Title = () => {
  switch (true) {
    case config.product_name === 'szmc':
      return 'שערי צדק אישי';
    case config.product_name === 'leumit':
      return <span style={{ direction: 'rtl', fontFamily: 'Open Sans Hebrew' }}></span>;
    case !!config.org_id && !['false', 'null', 'undefined'].includes(config.org_id):
      return 'רופא מכוון עד אליך';
    default:
      return <FormattedMessage id="app.headerStatus.default" defaultMessage="** Online Doctor" />;
  }
};

const HeaderStatus = () => (
  <h1 className={ theme.root }>
    <Title />
  </h1>
);

HeaderStatus.propTypes = propTypes;
HeaderStatus.defaultProps = defaultProps;

export default HeaderStatus;
